import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default _ref => {
  let {
    components,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `Maintaining open source projects is `, /*#__PURE__*/React.createElement("a", {
    href: "https://nolanlawson.com/2017/03/05/what-it-feels-like-to-be-an-open-source-maintainer/",
    target: "_blank"
  }, `hard work`), `. As Ant Design's user base has grown, we are getting more and more usage questions, bug reports, feature requests and pull requests every single day.`), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `As a free and open source project, Ant Design also has limited maintainer bandwidth. That means the only way to ensure the project's sustainability is to:`), /*#__PURE__*/React.createElement(MDXTag, {
    name: "ol",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ol"
  }, `Prioritize more concrete work (bug fixes and new features);`), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ol"
  }, `Improve issue triaging efficiency.`)), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `For (1), we have decided to use the GitHub issue lists exclusively for work that has well-defined, actionable goals. Questions and open ended discussions should be posted to mediums that are better suited for them.`), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `For (2), we have found that issues that do not provide proper information upfront usually results in terribly inefficient back-and-forth communication just to extract the basic information needed for actual triaging. This is exactly why we have created this app: to ensure that every issue is created with the necessary information, and to save time on both sides.`));
};